import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { BillingAccount, billingAccountService } from '../services/BillingAccountService';

export const BILLING_ACCOUNT_CACHE_KEY = 'billing_account';

export const useBillingAccount = (): UseQueryResult<BillingAccount> =>
  useQuery({
    queryFn: billingAccountService.get,
    queryKey: [BILLING_ACCOUNT_CACHE_KEY],
    staleTime: Infinity,
  });
